<div class="login-container">
  <h2>Login</h2>
  <form (ngSubmit)="login()">
    <label>
      Username:
      <input type="text" [(ngModel)]="username" name="username" required />
    </label>
    <br>
    <label>
      Password:
      <input type="password" [(ngModel)]="password" name="password" required />
    </label>
    <br>
    <button type="submit">Login</button>
    @if(message !== '') {
      <br>
      <p>{{message}}</p>
    }
  </form>
</div>